var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 4431 c-193 -36 -356 -160 -439 -333 -45 -96 -61 -161 -61 -258 0 -97 16 -162 62 -260 75 -157 227 -280 398 -321 85 -21 222 -17 305 9 253 77 425 309 425 572 0 268 -171 497 -430 574 -66 20 -198 28 -260 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3442 3226 c-157 -39 -315 -164 -386 -306 -49 -100 -66 -168 -66 -267 0 -110 14 -172 62 -272 48 -101 149 -208 243 -258 279 -147 612 -65 784 193 62 93 91 182 98 299 17 284 -172 539 -452 610 -71 18 -209 18 -283 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954 2887 c-51 -20 -101 -59 -128 -101 -14 -21 -90 -234 -170 -473 l-145 -433 181 2 181 3 112 335 112 335 438 0 438 0 54 -160 c29 -88 53 -163 53 -167 0 -5 -160 -8 -355 -8 l-355 0 0 -425 0 -425 -257 -2 -258 -3 0 -170 0 -170 908 -3 c499 -1 907 -3 907 -5 0 -1 -25 -77 -55 -167 -30 -90 -55 -166 -55 -167 0 -2 81 -3 179 -3 l179 0 114 343 115 342 435 3 436 2 114 -342 115 -343 176 -3 c138 -2 177 0 177 10 0 7 -66 211 -146 452 l-147 440 -47 47 c-80 80 -74 79 -675 79 -565 0 -580 -1 -650 -55 l-35 -26 0 295 0 296 -228 0 -227 0 -93 278 c-59 177 -101 289 -118 310 -14 17 -47 44 -72 60 l-47 27 -565 2 c-417 1 -573 -1 -596 -10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutor);
export default __webpack_public_path__ + "static/media/tutor.54ccd32c3c4f98f424b90121fddbc43a.svg";
export { ForwardRef as ReactComponent };